import { call, put } from 'redux-saga/effects';
import { calculateDistanceEngines } from 'constants/maps';
import {
  getHWYLocationFail,
  getHWYLocationSuccess,
  getHWYDistanceSuccess,
  getHWYDistanceFail,
} from 'redux/actions/hereWithYouActions';
import { getLocations } from 'api/hereWithYou';
import { getDistance } from 'api/getDistance';
import { parseCoordinatesToBing } from 'containers/Location/components/LocationWithBing/useLocationWithBing';

export function* getHereWithYouLocationSaga(action) {
  try {
    const { trackingIdentifier, hereWithYouToken } = action.payload;
    const response = yield call(getLocations, {
      trackingIdentifier,
      hereWithYouToken,
    });
    const { result, status } = response;
    if (status === 200) {
      yield put(getHWYLocationSuccess(result));
      return;
    }
    yield put(getHWYLocationFail(result));
  } catch (error) {
    yield put(getHWYLocationFail(error));
  }
}

export function* getHereWithYouDistanceSaga(action) {
  try {
    const { meetingPoint, providerPoint } = action.payload;
    if (!!meetingPoint && !!providerPoint) {
      const locationCoordFormatted = yield parseCoordinatesToBing(
        meetingPoint.location,
      );
      const destinationCoordFormatted = yield parseCoordinatesToBing(
        providerPoint.location,
      );

      const body = {
        originCoordinates: { ...locationCoordFormatted },
        destinationCoordinates: { ...destinationCoordFormatted },
        engine: calculateDistanceEngines.GOOGLE,
      };
      const response = yield call(getDistance, body);
      const { result, status } = response;
      if (status === 200) {
        yield put(getHWYDistanceSuccess(result));
        return;
      }
    }
    return null;
  } catch (error) {
    yield put(getHWYDistanceFail(error));
  }
}
